export const HOME_PAGE = "home";
